import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "cms-catalog-list",
  name: "栏目列表",
  icon: "目",
  group: "CMS通用",
  description: "展示当前站点的所有栏目。",
  defaultProps: {
    "showLogo": true,
    "showName": true,
    "showCount": true,
    "showDescription": false
}
}
